<template>
    <v-dialog v-model="modalProp" max-width="1300">
        <v-card>
            <v-card-title class="white">
                <v-row>
                    <div class="col-10" style="font-size:small;">
                        OPPA No: <span class="green--text">{{ historyData.OPAN_N }}</span>
                    </div>
                    <div class="col-2 d-flex justify-end">
                        <v-btn icon @click="modalProp = false">
                            <v-icon>{{ mdiClose }}</v-icon>
                        </v-btn>
                    </div>
                </v-row>
            </v-card-title>
            <v-divider />
            <br>
            <div style="margin:auto; width:90%">
                <b>Date Issued: </b> {{ moment(historyData.APPR_D).utcOffset('+0800').format("DD MMM YYYY") }} <br>
                <b>Valid Until: </b> {{ moment(historyData.VALI_D).utcOffset('+0800').format("DD MMM YYYY") }} <br>
                <br>
                <v-divider />
                <br>
                <b>Name: </b> {{ historyData.LAST_M }} {{ historyData.MIDI_M !== null? historyData.MIDI_M : "" }}<br>
                <b>Birthday: </b> {{ moment(historyData.BIRT_D).utcOffset('+0800').format("DD MMM YYYY") }}<br>
                <b>Age: </b> {{ historyData.AGE }} <br>
                <b>Contract No.:</b> {{ historyData.ACCT_N }}-{{ historyData.MEMB_N }}-{{ historyData.PROG_C }}<br>
                <br>
                <v-divider />
                <br>
                <b>Specialist: </b> {{ historyData.DOCT_S }} <br>
                <b>Medical Provider: </b> {{ historyData.TO_HOSP }} <br>
                <b>Requesting Specialist: </b> {{ historyData.DOCT_M }} <br>
                <b>Requesting Medical Provider: </b> {{ historyData.REQ_HOSP }} <br>
                <br>
                <v-divider />
                <br>
                <b>Particulars:</b>
                <div v-for="(item, index) in historyData.DIAPRO" :key="index">
                    {{ item.OID }}. {{ item.PDC }} - {{ item.DET }} <br>
                </div>
                <br>
                <v-divider />
                <br>
                <b>Diagnosis: </b> <br>
                {{ historyData.DIAG }} <br>
                {{ historyData.DIAG2 }} <br>
                <br>
                <b>Remarks: </b> <br>
                {{ historyData.REMA }} <br>
                <br>
                <v-divider />
                <br>
                <b>Bill: </b> {{ historyData.MALA }} <br>
                <br>
                <v-divider />
                <br>
                <b>Issued By: </b> {{ historyData.ISSU_N }} <br>
            </div>
            <br>
        </v-card>
    </v-dialog>
</template>
<script>
import { mdiClose } from '@mdi/js'

export default {
    props: ['historyData', 'show'],
    data: () => ({
        mdiClose
    }),
    computed: {
        modalProp: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('showDialog', val)
            }
        }
    }
}
</script>
